export function prepareUserData(data) {
  if (data.userId && data.webimHash) {
    var fields = {
      id: "".concat(data.userId)
    };

    if (data.displayName) {
      fields.display_name = data.displayName;
    }

    return {
      fields: fields,
      hash: data.webimHash
    };
  }

  return null;
}